'use client';

import { FaCircleArrowRight } from 'react-icons/fa6';

import { GTMEvents } from '@lib/utils/gtm/gtmEvents';
import sendGTMEvent from '@lib/utils/gtm/sendGTMEvent';
import { LinkButton } from '@ui/link-button';

export function MiniTunnelLink() {
  return (
    <LinkButton
      href="/devis"
      display={{
        lg: 'none',
      }}
      position="fixed"
      bottom="2"
      right="2"
      zIndex="sticky"
      size={{
        base: 'md',
        sm: 'lg',
      }}
      css={{
        '@media print': {
          display: 'none',
        },
      }}
      onClick={() =>
        sendGTMEvent({
          event: GTMEvents.CTA_BLOG_VIEW,
        })
      }
    >
      Comparer maintenant
      <FaCircleArrowRight />
    </LinkButton>
  );
}

export function TunnelLink() {
  return (
    <LinkButton
      href="/devis"
      onClick={() =>
        sendGTMEvent({
          event: GTMEvents.CTA_BLOG_VIEW,
        })
      }
    >
      Comparer maintenant
      <FaCircleArrowRight />
    </LinkButton>
  );
}
